/**
 * @example
 * encryptString(123) => 1**
 * encryptString(1231) => 1**1
 * encryptString(15123431) => 15****31
 * encryptString(15515545205) => 155****5205
 */
export const encryptString = (str, start = 3, end = 4) => {
  let _str = str + ''
  let _strLen = _str.length
  if (_strLen < 2) {
    return _str + '*'
  } else if (_strLen === 2 || _strLen === 3) {
    return _str[0] + '**'
  } else {
    if (_strLen > 3 && _strLen < 11) {
      console.log(parseInt(_strLen / 3))
      end = parseInt(_strLen / 3)
      start = parseInt(_strLen / 3)
    }
  }
  let re = new RegExp(`^(\\w{${start}})(\\w+)(\\w{${end}})$`, 'g')
  return _str.replace(re, '$1' + ('*'.repeat(_strLen - start - end)) + '$3')
}
